import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/inventory/index";

export const Route = createFileRoute("/admin/_modules/inventory")({
  component: Page,
});
